/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/news'>.
 * exact; render.ready[0][1]
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import News from '@routes/News';

export const Route = createFileRoute('/news/')({
  component: () => <CacheDataRoute component={News} path='/news' />
});
